import cn from 'classnames'
import {Icon} from 'src/common/Icon'

export type PlusButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
  ariaLabel?: string
  rotateIcon?: boolean
}

export const PlusButton = ({
  onClick,
  className = '',
  ariaLabel = 'View details',
  rotateIcon = false,
}: PlusButtonProps) => (
  <button
    onClick={onClick}
    className={`flex items-center justify-center rounded-[4px] border border-moss-grey-200 bg-moss-white p-[7px] transition-colors duration-300 hover:border-green-default hover:bg-green-neon group-hover:border-green-default group-hover:bg-green-neon ${className}`}
    aria-label={ariaLabel}
  >
    <Icon
      name="plus-bold-rounded"
      className={cn('size-3.5 text-moss-black transition-colors duration-300', {
        'rotate-45': rotateIcon,
      })}
    />
  </button>
)
